import React from 'react'
import MarketingLinksScreen from './MarketingLinksScreen'
import type { MarketingLinksScreenTexts } from './MarketingLinksScreen'

const TEXTS: MarketingLinksScreenTexts = {
  fallbackTitle: 'Materiais',
  fallbackDescription:
    'Cadastre materiais de marketing com título, descrição e link para download.',
  newButton: 'Novo material',
  modalCreateTitle: 'Novo material',
  modalEditTitle: 'Editar material',
  titlePlaceholder: 'Ex.: Manual da marca PASI',
  descriptionPlaceholder: 'Breve descrição do material',
  emptyFiltered: 'Nenhum material encontrado com os filtros atuais.',
  emptyList: 'Nenhum material cadastrado.',
  titleRequired: 'Informe o título do material.',
  loadError: 'Erro ao carregar materiais.',
  saveError: 'Erro ao salvar material.',
  deleteError: 'Erro ao excluir material.',
  deleteConfirm: (title) => `Excluir o material "${title}"?`,
  deleteReason: 'Exclusão pela tela de materiais',
  logView: (title) => `Visualizou material: ${title}`,
  logCreate: (title) => `Criou material: ${title}`,
  logUpdate: (title) => `Atualizou material: ${title}`,
  logDelete: (title) => `Excluiu material: ${title}`,
}

const MarketingMateriais: React.FC = () => (
  <MarketingLinksScreen
    moduleName="marketing_materiais"
    kind="materiais"
    logEntityType="marketing_material"
    texts={TEXTS}
  />
)

export default MarketingMateriais
